module.exports = __webpack_public_path__ + "img/mitaofei.e6f783cb.png";